// Vendor
import { combineReducers } from '@ngrx/store';
// Reducers
import { alertModalStatus } from './alert-modal-status/alert-modal-status.reducers';
import { metricAlertItems } from './metric-alert-items/metric-alert-items.reducers';
import { alertObject } from './alert-object/alert-object.reducers';
import { systemAlertItems } from './system-alert-items/system-alert-items.reducers';
export const ALERTS_MODAL_STATE_SLICE_KEY = 'alertsModal';
export const alertsModal = combineReducers({
    alertModalStatus,
    alertObject,
    metricAlertItems,
    systemAlertItems,
});
